<template>
  <div :class="b()">
    <slot />
  </div>
</template>

<script>
import create from '../utils/create';

export default create({
  name: 'goods-action'
});
</script>



// WEBPACK FOOTER //
// src/plugins/jscom/omui/components/goods-action/index.vue